import { MARQUEE_ITEMS } from "../data/content";

const Row = () => (
  <div className="flex shrink-0 items-center">
    {MARQUEE_ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="font-display whitespace-nowrap px-8 text-xl font-light italic text-[#1B3A5C]/80 sm:text-2xl">
          {item}
        </span>
        <span className="h-1.5 w-1.5 rounded-full border border-[#C9A66B]" aria-hidden="true" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="overflow-hidden border-y border-[#C9A66B]/25 bg-[#FAF7F2] py-5"
    aria-hidden="true"
  >
    <div className="marquee-track">
      <Row />
      <Row />
    </div>
  </div>
);
